import * as React from "react";
import { cva } from "class-variance-authority";

import { cn } from "../../lib/utils";

const alertVariants = cva(
	"relative w-full rounded-lg border p-4 [&>svg~*]:pl-7 [&>svg+div]:translate-y-[-3px] [&>svg]:absolute [&>svg]:left-4 [&>svg]:top-4 [&>svg]:text-foreground",
	{
		variants: {
			variant: {
				default: "bg-[var(--secondary-color)] text-[var(--text-color)] border-[var(--border-color)]",
				destructive:
					"border-red-500/50 text-red-900 dark:border-red-500 [&>svg]:text-red-900 bg-red-50 dark:bg-red-950 dark:text-red-50",
				warning:
					"border-yellow-500/50 text-yellow-900 dark:border-yellow-500 [&>svg]:text-yellow-900 bg-yellow-50 dark:bg-yellow-950 dark:text-yellow-50",
				success:
					"border-green-500/50 text-green-900 dark:border-green-500 [&>svg]:text-green-900 bg-green-50 dark:bg-green-950 dark:text-green-50",
			},
		},
		defaultVariants: {
			variant: "default",
		},
	}
);

const Alert = React.forwardRef(({ className, variant, ...props }, ref) => (
	<div
		ref={ref}
		role="alert"
		className={cn(alertVariants({ variant }), className)}
		{...props}
	/>
));
Alert.displayName = "Alert";

const AlertTitle = React.forwardRef(({ className, children, ...props }, ref) => (
	<h5
		ref={ref}
		className={cn("mb-1 font-medium leading-none tracking-tight", className)}
		{...props}
	>
		{children}
	</h5>
));
AlertTitle.displayName = "AlertTitle";

const AlertDescription = React.forwardRef(({ className, ...props }, ref) => (
	<div
		ref={ref}
		className={cn("text-sm [&_p]:leading-relaxed", className)}
		{...props}
	/>
));
AlertDescription.displayName = "AlertDescription";

export { Alert, AlertTitle, AlertDescription };
